import { ActionTypeCreator } from 'app-webtech-core/actions/actionType';

const ActionType = new ActionTypeCreator('USER_ACCOUNT');

export const REGISTER_WITH_EMAIL = ActionType.RSAA('REGISTER_WITH_EMAIL');
export const LOGIN_WITH_EMAIL = ActionType.RSAA('LOGIN_WITH_EMAIL');
export const LOGIN_WITH_FACEBOOK_TOKEN = ActionType.RSAA('LOGIN_WITH_FACEBOOK_TOKEN');
export const LOGIN_WITH_GOOGLE_TOKEN = ActionType.RSAA('LOGIN_WITH_GOOGLE_TOKEN');
export const LOGIN_WITH_TOKEN = ActionType.RSAA('LOGIN_WITH_TOKEN');
export const LOGIN_WITH_TWITTER_TOKEN = ActionType.RSAA('LOGIN_WITH_TWITTER_TOKEN');
export const LOGOUT = ActionType.RSAA('LOGOUT');
export const REQUEST_PASSWORD_RECOVERY = ActionType.RSAA('REQUEST_PASSWORD_RECOVERY');
export const RESET_PASSWORD_WITH_TOKEN = ActionType.RSAA('RESET_PASSWORD_WITH_TOKEN');
export const CHANGE_PASSWORD_WITH_TOKEN = ActionType.RSAA('CHANGE_PASSWORD_WITH_TOKEN');
export const UPDATE_EMAIL_WITH_TOKEN = ActionType.RSAA('UPDATE_EMAIL_WITH_TOKEN');
